import { render, staticRenderFns } from "./QuestionTable.vue?vue&type=template&id=5db7d35a&"
import script from "./QuestionTable.vue?vue&type=script&lang=js&"
export * from "./QuestionTable.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports